import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getHomePath } from '@/constants/routes';
import { selectIsAuthenticated, useAuthStore } from '@/stores/auth.store';

interface GuestGuardProps {
  children: ReactNode;
}

export function GuestGuard({ children }: GuestGuardProps) {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const user = useAuthStore((state) => state.user);

  if (isAuthenticated && user) {
    return <Navigate to={getHomePath(user)} replace />;
  }

  return <>{children}</>;
}
